import { useEffect, useState, useRef } from 'react'

import { useToast } from '../../hooks/toast'

import TextField from '../TextField'
import * as S from './styles'

import clientes from '../../api/clientes'

const TokenParceria = () => {
  const { addToast } = useToast()
  const [values, setValues] = useState({ token: '', status: 0 })
  const tokenRef = useRef(null)

  const handleChange = (value, field) => {
    setValues((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  const fetchToken = async () => {
    let valid = await clientes.getTokenParceria(values.token)
    if (valid.status === 200) {
      setValues((prev) => ({ ...prev, status: 1 }))
    } else {
      setValues((prev) => ({ ...prev, status: 2 }))
    }
  }

  const postToken = async (token) => {
    let post = await clientes.postTokenParceria(values.token)
    if (post.status === 200) {
      setValues({ token: '', status: 0 })
      return addToast({
        type: 'success',
        title: 'Token resgatado com sucesso'
      })
    } else {
      setValues({ token: '', status: 0 })
      return addToast({
        type: 'error',
        title: 'Sucesso',
        description: 'Token já resgatado'
      })
    }
  }

  useEffect(() => {
    if (values.token.length === 12) {
      fetchToken()
    } else if (values.status !== 0) {
      setValues((prev) => ({ ...prev, status: 0 }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.token])

  return (
    <>
      <S.Wrapper>
        <S.SubTitle>Token de Parceria</S.SubTitle>
        <S.Description>
          Se você for funcionário de uma parceria Gimba,{' '}
          <strong>informe seu token</strong> para poder resgatar o seu Gimplus e
          utilizá-lo em sua compra.
        </S.Description>
        <S.Box>
          <S.FormGroup>
            <TextField
              reference={tokenRef}
              maxlength={12}
              error={values.status === 2 && 'Token inválido ou já utilizado'}
              success={values.status === 1}
              name="token"
              placeholder="Informe seu Token"
              value={values.token}
              onChange={(e) => handleChange(e.target.value, 'token')}
            />
          </S.FormGroup>
          {values.status === 0 && <S.Validar>Validar</S.Validar>}
          {values.status === 1 && (
            <S.Resgatar onClick={() => postToken(values.token)}>
              Resgatar
            </S.Resgatar>
          )}
          {values.status === 2 && (
            <S.Limpar
              onClick={() => {
                setValues({ token: '', status: 0 })
                return tokenRef.current.focus()
              }}
            >
              Limpar
            </S.Limpar>
          )}
        </S.Box>
      </S.Wrapper>
    </>
  )
}

export default TokenParceria
